<template>
  <div class="balance">
    <div class="balance__header">
      <div class="balance__header__title">
        <h1 class="medium-title">Balance History</h1>
      </div>
      <div class="balance__header__filter">
        <div class="balance__header__filter__date">
          <div class="calendar">
              <v-date-picker
                :input-props='{ class: "date-input-range", readonly: true }'
                class='pickerFrom'
                :from-page.sync='fromPage'
                :theme-styles='themeStyles'
                :to-page.sync='toPage'
                :mode='mode'
                :select-color='selectColor'
                :dateFormatter='d => d.toLocaleDateString(["ban", "id"], { year: "numeric", month: "short", day: "numeric" })'
                :drag-color='dragColor'
                :disabled-dates='getDisabledStartDates'
                :is-inline='isInline'
                :is-expanded='isExpanded'
                :popover-expanded='popoverExpanded'
                :popover-visibility='startDateVisibility'
                :popover-direction='popoverDirection'
                :popover-align='popoverAlign'
                inputClass='date-input'
                v-model='startDate'>
              </v-date-picker>
            <i>-</i>
            <v-date-picker
                class='pickerTo'
                :input-props='{ class: "date-input-range", readonly: true }'
                :from-page.sync='fromPage'
                :to-page.sync='toPage'
                :mode='mode'
                :theme-styles='themeStyles'
                :select-color='selectColor'
                :dateFormatter='d => d.toLocaleDateString(["ban", "id"], { year: "numeric", month: "short", day: "numeric" })'
                :drag-color='dragColor'
                :disabled-dates='getDisabledEndDates'
                :is-inline='isInline'
                :is-expanded='isExpanded'
                :popover-expanded='popoverExpanded'
                :popover-visibility='endDateVisibility'
                :popover-direction='popoverDirection'
                :popover-align='popoverAlign'
                inputClass='date-input'
                v-model='endDate'>
              </v-date-picker>
          </div>
        </div>
        <div class="balance__header__filter__transaction">
          <dropdown-list class="dropdownDoc__item" @selected="selectType" :list="menuFilter" labelButton="All" />
        </div>
      </div>
    </div>
    <div class="balance__content">
      <list-item :items="sortedData" :loading="isLoading">
        <adx-loading v-if="isLoading" :loading="isLoading" slot="loading" />
      </list-item>
      <adx-pagination
        v-if="!isLoading && sortedData.length > 0"
        @change-page="changePage"
        :max-page="maxPage"
        :selected-page="currentPage"
       />
    </div>
  </div>
</template>

<script>
import calendar from 'v-calendar'
import DropdownList from '@/components/Dropdown/ListDropdown'
import ListItem from '@/views/Dashboard/BalanceHistory/ListItems'
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import moment from "moment";

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-dashboard-balance',
  components: {
    'v-calendar': calendar,
    DropdownList,
    ListItem,
    'adx-loading': Loading,
    'adx-pagination': Pagination
  },
  props: {
    mode: { type: String, default: 'single' },
    selectColor: { type: String, default: '#E22413' },
    dragColor: { type: String, default: '#9fcfdf' },
    showCaps: { type: Boolean, default: true },
    showPopover: { type: Boolean, default: true },
    showDisabledDates: { type: Boolean, default: true },
    isInline: { type: Boolean, default: false },
    isExpanded: Boolean,
    popoverExpanded: Boolean,
    popoverDirection: { type: String, default: 'bottom' },
    popoverAlign: { type: String, default: 'left' },
  },
  data() {
    return {
      title: 'Balance History',
      msgEmpty: 'You have no transactions.',
      startDate: new Date(),
      endDate: new Date(),
      progressBar1: 0,
      fromPage: null,
      toPage: null,
      currentPage: 1,
      maxPage: 1,
      selectedValueFrom: new Date(),
      selectedValueTo: new Date(),
      disabledStartDates: {
        start: new Date(+new Date() + 86400000),
        end: null,
      },
      disabledEndDates: [{
        start: new Date(+new Date() + 86400000),
        end: null,
      }],
      themeStyles: {
        dayContent: {
          fontSize: '1.5rem',
        },
        headerTitle: {
          fontSize: '1.5rem',
        }
      },
      selectValue: "",
      isLoading: true,
      nextPage: null,
      currentPage: 1,
      menuFilter: [
        {
          id: 0,
          label:'All',
          value: ''
        },
      ],
      transactions: [],
      balance: 0,
      startDateVisibility: 'focus',
      endDateVisibility: 'focus'
    }
  },
  computed: {
    sortedData() {
      return this.transactions;
    },
    getDisabledStartDates(){
      if (this.$data.endDate) return {
        start: new Date(+this.$data.endDate + 86400000),
        end: null,
      }
    },
    getDisabledEndDates(){
      if (this.$data.startDate) return [
        { start: new Date(+new Date() + 86400000), end: null},
        { start: null, end: this.$data.startDate - 86400000}
      ]
    },
  },
  watch: {
    startDate(){
      if(this.$data.endDate != null){
        this.$data.currentPage = 1;
        this.$data.transactions = [];
        this.getData(this.prepareQuery()); 
      }
      this.startDateVisibility = 'focus';
      this.openEndCalendar();
    },
    endDate(){
      this.endDateVisibility = 'focus';
      if(!this.$data.endDate){
        this.$data.endDate = new Date();
      }
      this.$data.currentPage = 1;
      this.$data.transactions = [];
      this.getData(this.prepareQuery()); 
    },
    currentPage() {
      this.getData(this.prepareQuery());
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    try {
      (async () => {
        const { data } = await api.get(apiV2.finalBalance, { needToken: true })
        if(data.balance != null){
          this.$data.balance = data.balance
        }
        const response = await api.get(apiV2.typeBalance, { needToken: true })
        const type = response.data
        for (var i=0; i < type.length; i++){
            this.$data.menuFilter.push(
                {
                  id: i+1,
                  label: type[i],
                  value: type[i]
                }
            )
        }
      })();
    } catch (err) {
      
    }
    this.getData(this.prepareQuery());
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectType(value){
      this.selectValue = value.value;
      this.$data.currentPage = 1;
      this.$data.transactions = [];
      this.getData(this.prepareQuery());
    },
    getData(data_query) {
      try {
        (async () => {
          this.$data.isLoading = true;
          const { data } = await api.get(apiV2.balanceHistory, { params: data_query, needToken: true })
          let transactions = data.results
          this.transactions = transactions
          this.maxPage = data.max_page
          this.$data.isLoading = false;
        })();
      } catch (err) {
        
      }
    },
    prepareQuery(){
      let query = {
        page: this.$data.currentPage,
        code_type: this.$data.selectValue,
      }
      if(this.$data.startDate != null){
        query.start = moment(this.$data.startDate).format('YYYY-MM-DD');
      }
      if(this.$data.endDate != null){
        query.end = moment(this.$data.endDate).format('YYYY-MM-DD');
      }
      return query;
    },

    openStartCalendar() {
      this.startDateVisibility = this.startDateVisibility == 'focus' ? 'visible' : 'focus';
    },
    openEndCalendar() {
      this.endDateVisibility = this.endDateVisibility == 'focus' ? 'visible' : 'focus';
    },
    changePage (selected) {
      this.$data.currentPage = selected;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      history.pushState(null, null, '?page=' + selected);
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
